export const SHORTLIST_PLACEHOLDER = '[shortlist]'

export const shortlistCommentKey = (applicantId: number): string =>
  `applicant-${applicantId}`

export const toShortlistComments = (
  applicantIds: number[],
  comments: Record<string, string> | undefined
): { applicantId: number; comment: string }[] =>
  applicantIds.flatMap((applicantId) => {
    const comment = comments?.[shortlistCommentKey(applicantId)]?.trim()
    return comment ? [{ applicantId, comment }] : []
  })
